/**
 * Hand back and Run it on mine take a running job off the machine that holds it and put it at the front of its queue.
 * The fleet decides who may, so this page only shows its answer.
 */

export type FleetHandBackMode = 'anyone' | 'mine'

export type FleetHandBackAllowed = { allowed: true } | { allowed: false; why: string }

export type FleetRunOnMineAllowed = { allowed: true; machine: string } | { allowed: false; why: string }

export interface FleetRunHandedBack {
  by: string
  byName: string
  at: string
  to: string
  state: 'stopping' | 'requeued'
}

export interface FleetRunHandBackEligibility {
  runId: string
  handBack: FleetHandBackAllowed
  runOnMine: FleetRunOnMineAllowed
  /** `label` names the job ("Fix adx#986"), `where` the place it runs ("Gibran's laptop", "AgentCore"). */
  what: { label: string; where: string }
  handedBack?: FleetRunHandedBack
  asOf: string
}

export interface FleetRunHandBackResult {
  runId: string
  state: 'stopping'
  mode: FleetHandBackMode
  to?: string
  machine?: string
  requeueBy: string
  text: string
}

export interface FleetRunHandBackReply {
  handBack: FleetRunHandBackResult
  asOf: string
}

export type FleetHandBackCheck =
  | { status: 'loading' }
  | { status: 'ready'; eligibility: FleetRunHandBackEligibility }
  | { status: 'failed'; why: string }

export const FLEET_HAND_BACK_CHECKING = 'Checking…'

/** How long a run's eligibility is reused before the menu asks the fleet again. */
export const FLEET_HAND_BACK_CHECK_TTL_MS = 30_000

/** How long Run it on mine offers the job to the engineer's own runner first; it must equal the fleet's `MINE_FOR_S` (120 s). */
export const FLEET_RUN_ON_MINE_MINUTES = 2

const HAND_BACK_KEEPS = 'Anything it already pushed or posted stays. The next free runner or AgentCore takes it.'

export function handBackConfirmText(eligibility: FleetRunHandBackEligibility, mode: FleetHandBackMode): string {
  const { label, where } = eligibility.what
  const stop = `Stop ${label} on ${where} and put it back at the front of the queue.`
  if (mode === 'anyone') return `${stop} ${HAND_BACK_KEEPS}`
  const machine = eligibility.runOnMine.allowed ? eligibility.runOnMine.machine : 'your runner'
  return `${stop} It is offered only to your runner (${machine}) for the next ${FLEET_RUN_ON_MINE_MINUTES} minutes, then to anyone. Anything it already pushed or posted stays.`
}

export function handedBackText(handedBack: Pick<FleetRunHandedBack, 'byName' | 'by'>): string {
  return `Handed back by ${handedBack.byName || handedBack.by}`
}
